<template>
    <div>
        <v-list-item @click.stop="dialog = true">
            <v-list-item-title>Edit</v-list-item-title>
        </v-list-item>
        <v-dialog width="700px" v-model="dialog">
            <v-card v-if="dialog">
                <v-card-title>
                    <span class="headline">Edit Shift, {{period_date | formatDate}}</span>
                    <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
                </v-card-title>
                <v-card-text class="dialog-card_body">
                    <v-row align="stretch">
                        <!-- left panel -->
                        <v-col xs="12" sm="3" md="3">
                            <v-row>
                                <v-col xs="12" sm="12" md="12">
                                    Driver info
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-list nav dense class="col">
                                    <v-list-item>
                                        <v-list-item-icon>
                                        <v-icon>mdi-calendar</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                        <v-list-item-title>__</v-list-item-title>
                                        <v-list-item-subtitle>Weekly Hours</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-list nav dense>
                                    <v-list-item>
                                        <v-list-item-icon>
                                        <v-icon>mdi-currency-gbp</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                        <v-list-item-title>___£</v-list-item-title>
                                        <v-list-item-subtitle>Weekly Cost</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-list nav dense>
                                    <v-list-item>
                                        <v-list-item-icon>
                                        <v-icon>mdi-clock-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                        <v-list-item-title>{{shiftLength}}</v-list-item-title>
                                        <v-list-item-subtitle>Shift Length</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <v-list nav dense>
                                    <v-list-item>
                                        <v-list-item-icon>
                                        <v-icon>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                        <v-list-item-title>£{{shiftCost}}</v-list-item-title>
                                        <v-list-item-subtitle>Shift Cost</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-row>
                            <v-row>
                                <v-col class="pl-0 pr-0">
                                    <v-divider></v-divider>
                                    <v-row no-gutters>
                                        <v-col v-if="creator" cols="12" sm="12" md="12">
                                            Shift Creator: #{{creator.id}} {{creator.full_name}} ({{creator.email}})
                                        </v-col>
                                        <v-col v-if="moderator" cols="12" sm="12" md="12">
                                            Shift Moderator: #{{moderator.id}} {{moderator.full_name}} ({{moderator.email}})
                                        </v-col>
                                        <v-col v-if="restaurateur_creator" cols="12" sm="12" md="12">
                                            Shift Creator: #{{restaurateur_creator.id}} {{restaurateur_creator.name}} ({{restaurateur_creator.email}})
                                        </v-col>
                                        <v-col v-if="restaurateur_moderator" cols="12" sm="12" md="12">
                                            Shift Moderator: #{{restaurateur_moderator.id}} {{restaurateur_moderator.name}} ({{restaurateur_moderator.email}})
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                        <!--/ left panel -->
                        <!-- right panel -->
                        <v-col xs="12" sm="9" md="9">
                            <v-form ref="form">
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <i v-if="driver_rejected_id" class="blue lighten-4"><v-icon style="font-size: 14px; color: #2196F3;">mdi-information-outline</v-icon> Shift rejected by {{getDriverFullName(driver_rejected_id)}}</i>
                                        <v-autocomplete
                                            label="Select driver"
                                            item-text="full_name"
                                            item-value="id"
                                            v-model="driver_id"
                                            :items="driverListSearched"
                                            :error-messages="selectDriverErrors"
                                            @input="$v.driver_id.$touch()"
                                            @blur="$v.driver_id.$touch()"
                                            required
                                            dense
                                            solo
                                        >
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                            class="hide-time-picker-indicator"
                                            type="time"
                                            menu-props="auto, overflowY"
                                            clear-icon="mdi-close"
                                            prepend-icon="mdi-clock-outline"
                                            clearable
                                            outlined
                                            label="Start Time*"
                                            hint="Example: 08:00"
                                            required
                                            v-model="start_time"
                                            :items="timeList"
                                            item-text="name"
                                            item-value="value"
                                            :error-messages="startTimeErrors"
                                            @input="$v.start_time.$touch()"
                                            @blur="$v.start_time.$touch()"
                                            dense
                                        >
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-autocomplete
                                            class="hide-time-picker-indicator"
                                            type="time"
                                            menu-props="auto, overflowY"
                                            clear-icon="mdi-close"
                                            prepend-icon="mdi-clock-outline"
                                            clearable
                                            outlined
                                            label="Finish Time*"
                                            hint="Example: 18:30"
                                            required
                                            v-model="finish_time"
                                            :items="timeList"
                                            item-text="name"
                                            item-value="value"
                                            :error-messages="finishTimeErrors"
                                            @input="$v.finish_time.$touch()"
                                            @blur="$v.finish_time.$touch()"
                                            dense
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            type="number"
                                            prepend-icon="mdi-wallet-giftcard"
                                            label="Add Driver Bonus"
                                            v-model="cost_bonus"
                                            required
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            type="number"
                                            prepend-icon="mdi-gas-station"
                                            label="Add Fuel Bonus"
                                            v-model="const_fuel_bonus"
                                            required
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            type="number"
                                            prepend-icon="mdi-wallet-giftcard"
                                            label="Cancellation fee/bonus"
                                            hint="hidden for restaurants"
                                            v-model="cost_extra_bonus"
                                            min="0"
                                            required
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                            <span class="adjustment-type">Extra Request</span>
                                            <v-checkbox
                                                v-model="extra_request"
                                                :true-value="1"
                                                :false-value="0"
                                                :label="`Yes`"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" sm="12" class="pb-0">
                                        <v-textarea
                                            outlined
                                            label="Comment"
                                            v-model="comment"
                                        ></v-textarea>
                                    </v-col>


                                    <v-col v-if="area_selected" sm="12" class="pb-0">
                                        <v-row>
                                            <v-col cols="12" sm="6" style="height: 80px"
                                                class="d-flex flex-column justify-space-between pa-0 pr-3">
                                                <span class="adjustment-type">Mon – Thurs Pay/Hr*</span>
                                                <!--<span class="adjustment">$200</span>-->
                                                <div class="adjustment">
                                                <!-- <span class="currency">&#163</span>-->
                                                    <v-text-field
                                                            prefix="£"
                                                            readonly
                                                            outlined
                                                            class="adjustment-input"
                                                            :value="restaurant_selected.standard_pay ? restaurant_selected.standard_pay : area_selected.standardPayRate"
                                                            required
                                                    ></v-text-field>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" sm="6" style="height: 80px"
                                                class="d-flex flex-column justify-space-between pa-0 pl-3">
                                                <span class="adjustment-type">Fri-Sun Pay/Hr*</span>
                                                <div class="adjustment">
                                                    <v-text-field
                                                            prefix="£"
                                                            readonly
                                                            outlined
                                                            class="adjustment-input"
                                                            :value="restaurant_selected.weekend_pay ? restaurant_selected.weekend_pay : area_selected.weekendPayRate"
                                                            required
                                                    ></v-text-field>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <div class="d-flex justify-center">
                                    <v-btn
                                            depressed
                                            class="mr-4 primary"
                                            :disabled="this.$v.$invalid || localLoading || selectDriverErrors.length > 0"
                                            :loading="localLoading"
                                            @click="submit"
                                    ><v-icon left>mdi-upload</v-icon>Save</v-btn>
                                    <v-btn
                                            class="mr-4"
                                            :loading="localLoading"
                                            depressed
                                            @click="clear"
                                    ><v-icon left>mdi-rotate-left</v-icon>Restore</v-btn>
                                    <v-btn
                                            class="mr-4 warning"
                                            :loading="localLoading"
                                            depressed
                                            @click="dialog=false"
                                    ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                                </div>

                            </v-form>
                        </v-col>
                        <!--/ right panel -->
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required,/* maxLength, email, numeric */ } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex';
import moment from 'moment';
import * as _ from 'lodash';
import { /*STATUS_NEW,*/ STATUS_ASSIGNED, STATUS_FREE, STATUS_STALE } from '../../store/shifts';

const IS_HOLIDAY = 10;
// const IS_REGULAR_DAY = 20;
const MODEL_TYPE_SHIFTS = 10;
const CANCELLED = 40;
const INSERTED = 10;
export default {
    mixins: [validationMixin],
    name: "EditShiftModal",
    props: ['shiftItem', 'shiftList'/*, 'restaurantItem'*/],
    validations: {
        driver_id: { required },
        start_time: { required,/* maxLength: maxLength(10)*/ },
        finish_time: { required },
        comment: { }
    },
    data: () => ({
        /*valid: false,*/
        readOnly: false,
        localLoading: false,
        dialog: false,
        // --
        driver_id: 0,
        driver_rejected_id: 0,
        status: '',
        status_assigned: '',
        period_date: '',
        start_time: '',
        finish_time: '',
        cost_per_hour: '',
        cost_total: '',
        cost_bonus: 0,
        const_fuel_bonus: 0,
        cost_extra_bonus: 0,
        comment: '',
        extra_request: 0,
        // --
        restaurant_selected: void 0,
        area_selected: void 0,
        is_initialized: false,
    }),
    updated() {
        if (this.$data.dialog && !this.$data.is_initialized) {
            this.$data.restaurant_selected = _.find(this.restaurants, p => {
                return p.id == this.$props.shiftItem.restaurant_id;
            });

            this.$data.area_selected = _.find(this.areas, p => {
                return p.id == this.$data.restaurant_selected.area_id;
            });

            if (this.$props.shiftItem.status_assigned == STATUS_STALE) {
                this.$data.driver_id = 0;
                this.driver_rejected_id = +this.$props.shiftItem.driver_id;
            } else {
                this.$data.driver_id = !this.$props.shiftItem.driver_id ? 0 : +this.$props.shiftItem.driver_id; // "driver_id === null" become 0
            }
            
            this.$data.status = this.$props.shiftItem.status;
            this.$data.status_assigned = this.$props.shiftItem.status_assigned;
            this.$data.period_date = this.$props.shiftItem.period_date;
            this.$data.start_time = this.$props.shiftItem.start_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.finish_time = this.$props.shiftItem.finish_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.cost_per_hour = this.$props.shiftItem.cost_per_hour;
            this.$data.cost_total = this.$props.shiftItem.cost_total;
            this.$data.cost_bonus = +this.$props.shiftItem.cost_bonus;
            this.$data.const_fuel_bonus = +this.$props.shiftItem.const_fuel_bonus;
            this.$data.cost_extra_bonus = +this.$props.shiftItem.cost_extra_bonus;
            this.$data.comment = this.$props.shiftItem.comment;
            this.$data.extra_request = +this.$props.shiftItem.extra_request;
            // created_at;
            // updated_at;

            this.$data.is_initialized = true;
        }
    },
    computed: {
        ...mapGetters(['areas', 'restaurants', 'timeList', 'restaurateurs']),
        ...mapGetters("user", {
            users: "users",
        }),
        driver_list() {
            return this.$store.getters.drivers;
        },
        creator() {
            return _.find(this.users, p => p.id == this.$props.shiftItem.creator_id);
        },
        moderator() {
            return _.find(this.users, p => p.id == this.$props.shiftItem.moderator_id);
        },
        restaurateur_creator() {
            return _.find(this.restaurateurs, p => p.id == this.$props.shiftItem.restaurateur_creator_id);
        },
        restaurateur_moderator() {
            return _.find(this.restaurateurs, p => p.id == this.$props.shiftItem.restaurateur_moderator_id);
        },
        driverListSearched() {
            let restaurant = _.find(this.restaurants, p => p.id == this.$props.shiftItem.restaurant_id)
            let drivers = _.filter(this.driver_list, driver => {
                if (driver.area_ids.length == 0) {
                    return true; // driver not assigned to any area
                }

                let driver_area_ids = _.map(driver.area_ids, p => p.area_id);
                if (driver_area_ids.indexOf(restaurant.area_id) === -1) {
                    return false;
                }

                // check driver assigned to restaurant
                if (driver.restaurant_ids.length == 0) {
                    return true; // driver not assigned to any restaurant
                }

                let driver_restaurant_item = _.find(driver.restaurant_ids, p => p.restaurant_id == restaurant.id);
                if (driver_restaurant_item) {
                    return true;
                }

                return false;
            });

            let free_driver = {
                id: 0,
                full_name: "Open shift",
            };

            drivers.unshift(free_driver);
            return drivers;
        },
        selectedDriverWorkingDay() {
            let driver = _.find(this.driver_list, p => p.id == this.$data.driver_id);
            if (!driver) {
                return [];
            }

            // try to find override dates
            let items = _.filter(driver.actual_override_working_time, p => p.period_date == this.$data.period_date);
            if (items.length > 0) {
                return items;
            }

            // try to find deafult weekday schedule
            let week_day = moment(this.$data.period_date, "YYYY-MM-DD").isoWeekday() - 1;
            items = _.filter(driver.default_working_time, p => p.week_day == week_day);

            return items;
        },
        selectDriverErrors () {
            const errors = [];
            // if (!this.$v.driver_id.$dirty) {
            //     return errors;
            // }

            // check is driver already have shift on this day
            let this_driver_shifts = _.filter(this.$props.shiftList, p => {
                return p.driver_id == this.$data.driver_id && p.period_date == this.$data.period_date && p.id != this.$props.shiftItem.id && p.status == 20
            });
            for (let i = 0; i < this_driver_shifts.length; i++) {
                // check restaurant intersection (one day => one timesheet)
                /*if (this_driver_shifts[i].restaurant_id == this.$props.shiftItem.restaurant_id) {
                    errors.push('Driver already have shift on this day');
                    break; // exit
                }*/

                // check time intersection
                if (moment(this.$data.start_time, "HH:mm").format('HH:mm') < moment(this.$data.finish_time, "HH:mm").format('HH:mm')) {
                    if (
                        this.isTimeIntersects(this_driver_shifts[i].start_time, this_driver_shifts[i].finish_time, this.$data.start_time)
                        || this.isTimeIntersects(this_driver_shifts[i].start_time, this_driver_shifts[i].finish_time, this.$data.finish_time)
                        || this.isTimeIntersects(this.$data.start_time, this.$data.finish_time, this_driver_shifts[i].start_time)
                        || this.isTimeIntersects(this.$data.start_time, this.$data.finish_time, this_driver_shifts[i].finish_time)
                    ) {
                        errors.push('Driver already have shift on this time');
                        break;
                    }
                } else {
                    //?
                }
            }

            // check drivers working time intersections
            if (!_.isEmpty(this.selectedDriverWorkingDay)) {
                let driver_working_time_labels = _.map(this.selectedDriverWorkingDay, p => {
                    return moment(p.start_at, "HH:mm").format('HH:mm') + '-' + moment(p.stop_at, "HH:mm").format('HH:mm')
                });

                let is_holiday = false;
                let is_itersection_start_founded = false;
                let is_itersection_finish_founded = false;
                _.each(this.selectedDriverWorkingDay, p => {
                    if (is_holiday || is_itersection_start_founded || is_itersection_finish_founded) return;

                    if (p.holiday == IS_HOLIDAY) {
                        is_holiday = true;
                    }
                        
                    if (this.isTimeIntersects(p.start_at, p.stop_at, this.$data.start_time)) {
                        is_itersection_start_founded = true;
                    }
                    
                    if (this.isTimeIntersects(p.start_at, p.stop_at, this.$data.finish_time)) {
                        is_itersection_finish_founded = true;
                    }
                });

                is_holiday && errors.push('Driver unavailable');
                !is_itersection_start_founded && errors.push('Driver working time: ' + driver_working_time_labels.join(', '));
                !is_itersection_finish_founded && errors.push('Driver working time: ' + driver_working_time_labels.join(', '));

                // if time not filled show information message (as error)
                !this.$data.start_time && errors.push('Driver working time: ' + driver_working_time_labels.join(', '));
                !this.$data.finish_time && errors.push('Driver working time: ' + driver_working_time_labels.join(', '));
            }

            !this.$v.driver_id.required && errors.push('Driver is required');

            return errors
        },
        startTimeErrors () {
            const errors = [];
            if (!this.$v.start_time.$dirty) {
                return errors;
            }
            !this.$v.start_time.required && errors.push('Start Time is required.')
            !moment(this.$data.start_time, "HH:mm").isValid() && errors.push('Start Time invalid format.')
            return errors
        },
        finishTimeErrors () {
            const errors = [];
            if (!this.$v.finish_time.$dirty) {
                return errors;
            }
            !this.$v.finish_time.required && errors.push('Start Time is required.')
            !moment(this.$data.finish_time, "HH:mm").isValid() && errors.push('Finish Time invalid format.')
            return errors
        },
        contactNameErrors () {
            const errors = [];
            if (!this.$v.contactName.$dirty) {
                return errors;
            }
            !this.$v.contactName.required && errors.push('Contact Name is required.');
            return errors
        },
        /**
         * calculate Shift Length
         * result: (finish_time - start_time)
         */
        shiftLength: function() {
            let finish_time = moment(this.$data.finish_time, "HH:mm");
            let start_time = moment(this.$data.start_time, "HH:mm");
            if (!finish_time.isValid() || !start_time.isValid()) {
                return 0;
            }

            if (this.$data.finish_time < this.$data.start_time) {
                finish_time.add(1, 'days');
            }

            let total_time_hours = ( (finish_time - start_time) / (60 * 1000) ) / 60;

            return total_time_hours.toFixed(2); // round
        },
        shiftCostPerHour: function() {
            if (!this.$data.area_selected || !this.$data.restaurant_selected) {
                return 0;
            }

            let cost_per_hour = this.$data.restaurant_selected.standard_pay ? this.$data.restaurant_selected.standard_pay : this.$data.area_selected.standardPayRate;
            // check date is weekend, then get weekend rate
            let shift_date = moment(this.$data.period_date, "YYYY-MM-DD");
            if(shift_date.isoWeekday() === 5 || shift_date.isoWeekday() === 6 || shift_date.isoWeekday() === 7) {
                cost_per_hour = this.$data.restaurant_selected.weekend_pay ? this.$data.restaurant_selected.weekend_pay : this.$data.area_selected.weekendPayRate;
            }

            return cost_per_hour;
        },
        shiftCost: function() {
            return ((+this.shiftCostPerHour * this.shiftLength) + +this.cost_bonus + +this.const_fuel_bonus).toFixed(2);
        },
    },

    methods: {
        submit () {
            this.localLoading = true;
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$data.cost_per_hour = this.shiftCostPerHour;
                this.$data.cost_total = this.shiftCost;

                const shift_data = {
                    id: this.$props.shiftItem.id,
                    restaurant_id: this.$props.shiftItem.restaurant_id,
                    driver_id: this.$data.driver_id,
                    status: this.$data.status,
                    status_assigned: this.$data.driver_id ? STATUS_ASSIGNED : STATUS_FREE,
                    period_date: this.$data.period_date,
                    start_time: this.$data.start_time,
                    finish_time: this.$data.finish_time,
                    meal_time: 0,
                    rest_time: 0,
                    cost_per_hour: this.$data.cost_per_hour,
                    cost_total: this.$data.cost_total,
                    cost_bonus: this.$data.cost_bonus,
                    const_fuel_bonus: this.$data.const_fuel_bonus,
                    cost_extra_bonus: this.$data.cost_extra_bonus,
                    comment: this.$data.comment,
                    extra_request: this.$data.extra_request,
                    // created_at: void 0,
                    // updated_at: void 0,
                };

                if (shift_data.driver_id == 0) { // fix 0 to null
                    shift_data.driver_id = null;
                }

                this.$store.dispatch('editShift', shift_data).then(() => {
                    this.dialog = false;
                    this.is_initialized = false;
                    //Bonus Added to be reported
                    if (Number(this.cost_extra_bonus) > 0) {
                        const shift_data = {
                            restaurant_id: this.$props.shiftItem.restaurant_id,
                            driver_id: this.$data.driver_id ? this.$data.driver_id : null,
                            shift_id: this.$props.shiftItem.id,
                            period_date: this.$data.period_date,
                            cost: Number(this.$data.cost_extra_bonus),
                            comment_cancelled: this.$data.comment,
                            model_type: MODEL_TYPE_SHIFTS,
                            event: INSERTED,
                            model_id: this.$props.shiftItem.id
                        };
                    this.$store.dispatch('cancelShift', shift_data);
                }
                this.clear();
                }).finally(() => {
                    this.localLoading = false;
                });
            }
        },
        clear () {
            this.$v.$reset();
            this.$data.restaurant_id = this.$props.shiftItem.restaurant_id;

            if (this.$props.shiftItem.status_assigned == STATUS_STALE) {
                this.$data.driver_id = 0;
                this.driver_rejected_id = +this.$props.shiftItem.driver_id;
            } else {
                this.$data.driver_id = !this.$props.shiftItem.driver_id ? 0 : +this.$props.shiftItem.driver_id; // "driver_id === null" become 0
            }

            this.$data.status = this.$props.shiftItem.status,
            this.$data.status_assigned = this.$props.shiftItem.status_assigned,
            this.$data.period_date = this.$props.shiftItem.period_date;
            this.$data.start_time = this.$props.shiftItem.start_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.finish_time = this.$props.shiftItem.finish_time.substr(0, 5); // format time from HH:mm:ss to HH:mm
            this.$data.cost_per_hour = this.$props.shiftItem.cost_per_hour;
            this.$data.cost_total = this.$props.shiftItem.cost_total;
            this.$data.cost_bonus = +this.$props.shiftItem.cost_bonus;
            this.$data.const_fuel_bonus = +this.$props.shiftItem.const_fuel_bonus;
            this.$data.cost_extra_bonus = +this.$props.shiftItem.cost_extra_bonus;
            this.$data.comment = this.$data.shiftItem.comment;
            this.$data.extra_request = this.$props.shiftItem.extra_request;
        },
        isTimeIntersects(start_at, stop_at, check) {
            if (!check) {
                return false;
            }

            if (moment(start_at, "HH:mm").format('HH:mm') < moment(stop_at, "HH:mm").format('HH:mm')) {
                return moment(start_at, "HH:mm").format('HH:mm') <= moment(check, "HH:mm").format('HH:mm')
                    && moment(stop_at, "HH:mm").format('HH:mm') >= moment(check, "HH:mm").format('HH:mm');
            } else {
                return moment(start_at, "HH:mm").format('HH:mm') <= moment(check, "HH:mm").format('HH:mm');
            }
        },
        getDriverFullName: function(driver_id) {
            let driver = _.find(this.driver_list, p => p.id == driver_id);
            if (!driver) {
                return '-';
            }

            return driver.full_name;
        },
    },
    filters: {
      formatDate: function (date) {
        return moment(date, "YYYY-MM-DD").format('MMM Do');
      },
    },
}
</script>

<style scoped>

</style>